export default "__VITE_ASSET__B95EVJM4__"